import { BaseWidgetFormFields } from 'components/consumer-page-widgets/BaseWidgetFormFields';
import { Button, Typography } from 'ui';
import {
  ButtonArrayWidgetFields,
  ButtonArrayWidgetFormFields,
} from 'components/consumer-page-widgets/button-array-widget/ButtonArrayWidgetFormFields';
import { Form, Formik } from 'formik';
import { consumer } from '@tock/coretypes';
import {
  getBaseFormFieldsInitialValues,
  useUpdateNamedConfigurations,
} from 'components/consumer-page-widgets/widgetFormUtils';
import {
  widgetFormButtonContainer,
  widgetFormRoot,
} from 'components/consumer-page-widgets/widgetFormCssDefs';
import React, { FunctionComponent } from 'react';

interface UpdateButtonArrayWidgetFormProps {
  selectedWidgetToEdit?: consumer.NamedConfiguration;
  onCompleteOrCancel(): void;
}

export const UpdateButtonArrayWidgetForm: FunctionComponent<
  React.PropsWithChildren<UpdateButtonArrayWidgetFormProps>
> = ({ selectedWidgetToEdit, onCompleteOrCancel }) => {
  const updateNamedConfig = useUpdateNamedConfigurations();

  if (!selectedWidgetToEdit?.buttonArrayWidgetConfig) {
    return null;
  }

  const handleSubmit = ({
    buttonCountLimit,
    buttonCountLimitDesktop,
    aggregationCountMinimum,
    heading,
    tagType,
    includeVerticalSpacing,
  }: ButtonArrayWidgetFields) => {
    return updateNamedConfig({
      ...selectedWidgetToEdit,
      buttonArrayWidgetConfig: {
        buttonCountLimit,
        buttonCountLimitDesktop,
        aggregationCountMinimum,
        heading,
        tagType,
        includeVerticalSpacing,
      },
    }).then(onCompleteOrCancel);
  };

  const {
    buttonCountLimit,
    buttonCountLimitDesktop,
    aggregationCountMinimum,
    tagType,
    heading,
    includeVerticalSpacing,
  } = selectedWidgetToEdit.buttonArrayWidgetConfig;

  return (
    <>
      <Typography variant="heading1Bold">Editing widget: {selectedWidgetToEdit.name}</Typography>
      <Formik<ButtonArrayWidgetFields>
        enableReinitialize
        initialValues={{
          ...getBaseFormFieldsInitialValues({ widgetToEdit: selectedWidgetToEdit }),
          heading: heading ?? '',
          buttonCountLimit: buttonCountLimit ?? 0,
          buttonCountLimitDesktop: buttonCountLimitDesktop ?? 0,
          aggregationCountMinimum: aggregationCountMinimum ?? 0,
          tagType: tagType ?? 'WINE_FLAVOR',
          includeVerticalSpacing: includeVerticalSpacing ?? true,
        }}
        onSubmit={handleSubmit}
      >
        <Form css={widgetFormRoot}>
          <BaseWidgetFormFields />
          <ButtonArrayWidgetFormFields />
          <div css={widgetFormButtonContainer}>
            <Button type="submit">Submit</Button>
            <Button onClick={onCompleteOrCancel} type="button" variant="outlined">
              Cancel
            </Button>
          </div>
        </Form>
      </Formik>
    </>
  );
};
